import React, { useEffect, useState, useRef } from "react";
import "./Managetexmaster.css";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import Button from "@mui/material/Button";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import toast, { Toaster } from "react-hot-toast";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import activeIcon from "../../../Assests/activeIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import { PiLightbulb } from "react-icons/pi";
import { FaEdit } from "react-icons/fa";
import CommonButton from "../../../Componants/Common/Button";
import Paginate from "../../../Componants/Common/Paginate";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import config from "../../../Componants/Common/config";
import Subheader from "../../../Componants/Common/Subheader";
import axios from "axios";
import {
  createTax,
  getTaxes,
  filterHsnCode,
  updateTaxStatus,
  deleteTax,
  updateTax,
  exportTax,
} from "../../../API Service/apiService";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Constants } from "../../../constants/Constants";
import Loader from "../../../Componants/Common/Loader";
import { downloadFile } from "../../../utils/downloadHelper";


const calltype = [];

const validationSchema = Yup.object({
  hsnCode: Yup.string()
    .required("HSN Code is required")
    .matches(/^[a-zA-Z0-9]+$/, "Only alphanumeric characters are allowed")
    .max(50, "HSN Code must be at most 50 characters"),
  description: Yup.string()
    .required("Description is required")
    .max(100, "Description must be at most 100 characters"),
  cgst: Yup.number()
    .required("CGST is required")
    .typeError("CGST must be a number")
    .test(
      "decimal-places",
      "CGST can have at most 2 decimal places",
      (value) =>
        value === undefined ||
        value === null ||
        /^\d+(\.\d{0,2})?$/.test(value.toString())
    ),
  sgst: Yup.number()
    .required("SGST is required")
    .typeError("SGST must be a number")
    .test(
      "decimal-places",
      "SGST can have at most 2 decimal places",
      (value) =>
        value === undefined ||
        value === null ||
        /^\d+(\.\d{0,2})?$/.test(value.toString())
    ),
  igst: Yup.number()
    .required("IGST is required")
    .typeError("IGST must be a number")
    .test(
      "decimal-places",
      "IGST can have at most 2 decimal places",
      (value) =>
        value === undefined ||
        value === null ||
        /^\d+(\.\d{0,2})?$/.test(value.toString())
    ),
  utgst: Yup.number()
    .required("UTGST is required")
    .typeError("UTGST must be a number")
    .test(
      "decimal-places",
      "UTGST can have at most 2 decimal places",
      (value) =>
        value === undefined ||
        value === null ||
        /^\d+(\.\d{0,2})?$/.test(value.toString())
    ),
});

const Managetexmaster = () => {
  const topRef = useRef(null);
  const pageSize = config.pageSize;
  const dummyGetList = {
    serialNo: "",
    hsncode: "",
    cgst: "",
    sgst: "",
    iggst: "",
    utgst: "",
    pageSize: pageSize,
  };
  const [value, setValue] = React.useState({});

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };

  const [searchParams, setParams] = useState({
    ...dummyGetList,
  });

  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [taxes, setTaxes] = useState([]);
  const [dataSize, setDataSize] = useState(pageSize);
  const [search, setSearch] = useState("");
  const [dropSearch, setDropSearch] = useState("");
  const [dropTaxes, setDropTaxes] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [taxId, setTaxId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTaxes();
  }, [page]); // Fetch taxes when page or search changes

  useEffect(() => {
    fetchDropTaxes();
    fetchDropTaxes();
  }, []);

  const fetchTaxes = async () => {
    try {
      setLoading(true);
      const response = await getTaxes(search, page, 10); // Pass page and limit
      setTaxes(response.data.taxes);
      setTotalRecords(response.data.totalTaxes);
    } catch (error) {
      console.error("Error fetching taxes:", error);
      toast.error("Failed to fetch taxes");
    } finally {
      setLoading(false);
    }
  };

  const fetchDropTaxes = async () => {
    try {
      setLoading(true);
      const response = await getTaxes(search, page, 1000); // Pass page and limit
      setDropTaxes(response.data.taxes || []);
    } catch (error) {
      console.error("Error fetching taxes:", error);
      toast.error("Failed to fetch tax options");
    } finally {
      setLoading(false);
    }
  };

  const filterTaxes = async () => {
    try {
      setLoading(true);
      const response = await filterHsnCode(dropSearch, page, 10); // Pass page and limit
      setTaxes(response.data.taxes || []);
      if (response.data.taxes?.length === 0) {
        toast.error("No taxes found matching the search criteria");
      }
    } catch (error) {
      console.error("Error filtering taxes:", error);
      toast.error("Failed to filter taxes");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);

    setParams((prevParams) => ({
      ...prevParams,
      pageIndex: newPage.toString(),
    }));
  };

  const formik = useFormik({
    initialValues: {
      hsnCode: "",
      description: "",
      cgst: "",
      sgst: "",
      igst: "",
      utgst: "",
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);
        setSubmitting(true);

        if (isEditMode) {
          const editBody = {
            taxId,
            ...values,
          };
          const response = await updateTax(editBody);
          if (response.status === "success") {
            toast.success("Tax updated successfully");
            fetchTaxes();
            fetchDropTaxes();
            formik.resetForm();
            setIsEditMode(false);
          } else {
            toast.error(response.message || "Failed to update tax");
          }
        } else {
          const response = await createTax(values);
          if (response.status === "success") {
            toast.success("Tax added successfully");
            fetchTaxes();
            fetchDropTaxes();
            formik.resetForm();
          } else {
            toast.error(response.message || "Failed to create tax");
          }
        }
      } catch (error) {
        console.error("Form submission error:", error);
        toast.error(error.response?.data?.message || "Failed to save tax");
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const handleEdit = (index) => {
    try {
      const editBody = taxes[index];
      setTaxId(editBody._id);
      formik.setValues({
        hsnCode: editBody.hsnCode,
        description: editBody.description,
        cgst: editBody.cgst,
        sgst: editBody.sgst,
        igst: editBody.igst,
        utgst: editBody.utgst,
      });
      setIsEditMode(true);
      scrollToTop();
    } catch (error) {
      console.error("Error setting edit values:", error);
      toast.error("Failed to load tax details for editing");
    }
  };

  const handleStatus = async (hsnCode, status) => {
    try {
      setLoading(true);
      const body = {
        hsnCode,
        status: !status,
      };
      const response = await updateTaxStatus(body);
      if (response.status === "success") {
        toast.success("Status updated successfully");
        fetchTaxes();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    } finally {
      setLoading(false);
    }
  };
  const exportExcel = async () => {
    try {
      setLoading(true);
      const updatedParams = { hsnCode:dropSearch, page: -1, limit: -1 };
      const response = await exportTax(updatedParams);
      if (response?.status === "success" && response?.data?.filePath) {
        downloadFile(response.data.filePath);
        toast.success("File downloaded successfully");
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error exporting taxes:", error);
      toast.error(error.message || "Export failed");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchChange = async (event, newValue) => {
    setDropSearch(newValue?.hsnCode || "");
  };

  const handleSearchClick = async () => {
    setPage(1); // Reset to first page when searching
    await filterTaxes();
    // await fetchDropTaxes(); // Re-fetch dropdown options
    // setDropSearch("")
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="Managetexmaster-container" ref={topRef}>
      <HeaderNavigation value={"Tax"} location={"/setting"} />
      <Toaster />
      {loading && <Loader />}

      <div className="autocompleteform-Managetexmaster">
        <div className="textbox-main-Managetexmaster">
          <div className="line-Managetexmaster">
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="HSN Code"
                variant="standard"
                value={formik.values.hsnCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="hsnCode"
                required
                error={formik.touched.hsnCode && Boolean(formik.errors.hsnCode)}
                helperText={formik.touched.hsnCode && formik.errors.hsnCode}
              />
            </div>
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="Description"
                variant="standard"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="description"
                required
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
              />
            </div>
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="CGST%"
                variant="standard"
                value={formik.values.cgst}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="cgst"
                required
                error={formik.touched.cgst && Boolean(formik.errors.cgst)}
                helperText={formik.touched.cgst && formik.errors.cgst}
              />
            </div>
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="SGST%"
                variant="standard"
                value={formik.values.sgst}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="sgst"
                required
                error={formik.touched.sgst && Boolean(formik.errors.sgst)}
                helperText={formik.touched.sgst && formik.errors.sgst}
              />
            </div>
          </div>
          <div className="line-Managetexmaster">
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="IGST%"
                variant="standard"
                value={formik.values.igst}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="igst"
                required
                error={formik.touched.igst && Boolean(formik.errors.igst)}
                helperText={formik.touched.igst && formik.errors.igst}
              />
            </div>
            <div className="textinput-Managetexmaster">
              <TextField
                style={{ width: "100%" }}
                label="UTGST%"
                variant="standard"
                value={formik.values.utgst}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="utgst"
                required
                error={formik.touched.utgst && Boolean(formik.errors.utgst)}
                helperText={formik.touched.utgst && formik.errors.utgst}
              />
            </div>
          </div>

          <div className="button-Managetexmaster">
            <span>
              <CommonButton
                name={isEditMode ? Constants.update : Constants.create}
                handleOnClick={() => formik.handleSubmit()}
              />
            </span>

            <span className="buttons-Managetexmaster-span">
              <CommonButton
                name={Constants.cancel}
                handleOnClick={() => {
                  formik.resetForm();
                  setIsEditMode(false);
                }}
              />
            </span>
          </div>
        </div>
      </div>

      <div className="autocompleteform-Managetexmaster">
        <Subheader heading={"List View"} />
        <div className="line-Managetexmaster">
          <div className="textinput-Managetexmaster">
            <Autocomplete
              id="disable-close-on-select"
              options={dropTaxes}
              getOptionLabel={(option) => option.hsnCode}
              value={
                dropTaxes.find((option) => option.hsnCode === dropSearch) ||
                null
              }
              onChange={handleSearchChange}
              renderInput={(params) => (
                <TextField {...params} label="HSN Code" variant="standard" />
              )}
            />
          </div>
          <div className="button-group">
            <CommonButton
              name={Constants.search}
              handleOnClick={handleSearchClick}
            />
          </div>
          <div className="button-group">
            <CommonButton
              name={Constants.cancel}
              handleOnClick={() => {
                setDropSearch("");
                setPage(1);
                fetchTaxes();
              }}
            />
          </div>
        </div>

        <div className="table-Managetexmaster">
          <div className="excelexport-Managetexmaster">
            <span className="buttons-Managetexmaster-span">
              <ExportToExcel onClick={exportExcel} />
            </span>
          </div>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="tax table">
              <TableHead
                sx={{
                  backgroundColor: "#33499F",
                  color: "white",

                  fontSize: "1.1rem",
                  fontWeight: 500,
                }}
              >
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",

                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    HSN Code & Description
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",

                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    CGST
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",

                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    SGST
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",

                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    IGST
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",
                      backgroundColor: "#33499F",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    UTGST
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "white",
                      backgroundColor: "#33499F",
                      fontSize: "1.1rem",
                      fontWeight: 500,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {taxes.map((tax, index) => (
                  <TableRow key={tax._id}>
                    <TableCell align="center">
                      {tax.hsnCode} - {tax.description}
                    </TableCell>
                    <TableCell align="center">{tax.cgst + "%"}</TableCell>
                    <TableCell align="center">{tax.sgst + "%"}</TableCell>
                    <TableCell align="center">{tax.igst + "%"}</TableCell>
                    <TableCell align="center">{tax.utgst + "%" || "N/A"}</TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconButton
                        onClick={() => handleStatus(tax.hsnCode, tax.status)}
                        sx={{
                          outline: "none",
                          "&:focus": { outline: "none" },
                        }}
                      >
                        <img
                          src={tax.status === false ? inactiveIcon : activeIcon}
                          alt="active"
                          height="20px"
                          width="20px"
                        />
                      </IconButton>

                      <IconButton
                        onClick={() => {
                          handleEdit(index);
                          scrollToTop();
                        }}
                        sx={{
                          outline: "none",
                          "&:focus": { outline: "none" },
                        }}
                      >
                        <img
                          src={editIcon}
                          alt="Edit"
                          height={"20px"}
                          width={"20px"}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </div>
    </div>
  );
};

export default Managetexmaster;
